import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FipService {
  async fetch(url: string, env: string | undefined, method: string = 'GET', body?: any): Promise<any> {
    const requestOptions = this._createRequestOptions(env, method, body);
    return await fetch(url, requestOptions);
  }

  private _createRequestOptions(env: string | undefined, method: string, body?: any): RequestInit {
    const requestOptions: RequestInit = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: env !== 'local' ? 'include' : 'same-origin'
    };

    // Add body for POST request
    if (body && ['POST'].includes(method.toUpperCase())) {
      requestOptions.body = JSON.stringify(body);
    }

    return requestOptions;
  }
}

